import classNames from 'classnames';
import { useEffect, useRef } from 'react';
import logTripPlannerCTAViewed from '@alltrails/amplitude/events/logTripPlannerCTAViewed';
import IconTile from '@alltrails/denali/components/IconTile';
import TableRow from '@alltrails/denali/components/TableRow';
import Sparkle from '@alltrails/denali/icons/Sparkle';
import styles from './styles/styles.module.scss';

/**
 * The trip planner entry point as a row inside a search dropdown's result list.
 *
 * https://www.figma.com/design/jRyJm5tO66lHSa0E8PSox2/H2--26-Trip-planner?node-id=2704-84578&m=dev
 */
const TripPlannerResultContent = () => {
  const hasLoggedViewRef = useRef(false);

  useEffect(() => {
    if (hasLoggedViewRef.current) {
      return;
    }
    hasLoggedViewRef.current = true;
    logTripPlannerCTAViewed({ entry_point: 'search result' });
  }, []);

  return (
    <TableRow
      className={classNames(styles.listItemContent, styles.alignCenter)}
      leftContent={<IconTile icon={{ Component: Sparkle }} />}
      // trip planner is only available to en-US, so this copy is intentionally not translated
      label={<div className={styles.label}>Trip Assistant</div>}
      description={
        <div className={styles.description}>
          <span>Plan your next trip</span>
        </div>
      }
    />
  );
};

export default TripPlannerResultContent;
